import React from 'react';
import types from './types';

import UIEditorSubcomponent from '../UIEditorSubcomponent';

export default function UIVoice(props)
{
	let properties = {
		Voice: {
			type: 'textarea',
			id: 'voice'
		}
	}

	if(props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor') 
	{
		return (
			<UIEditorSubcomponent
				title={'Voice'}
				subcomponent={types.VOICE}
				properties={properties}
				{...props}
			/>
		)
	}

	return null;
}